function chartClickEvent(event, array, chartInstance, vm) {
	var active_toopTip = chartInstance.tooltip._active;

	if (active_toopTip.length > 0) {
		for (var i = 0; i < active_toopTip.length; i++) {
			const chartIndex = chartInstance.tooltip._active[i]._index;
			chartInstance.selectedIndex = chartIndex;
			const dataSetIndex = chartInstance.tooltip._active[i]._datasetIndex;
			chartInstance.selectedValueIndex = dataSetIndex;

			const selectedChartTypeName = chartInstance.tooltip._data.datasets[dataSetIndex].type;
			const selectedChartValue = chartInstance.tooltip._data.datasets[dataSetIndex].data[chartIndex];
			const selectedChartCategoryName = chartInstance.tooltip._data.labels[chartIndex];
			const selectedChartName = chartInstance.tooltip._data.datasets[dataSetIndex].label;

			const selDataKey = chartInstance.tooltip._data.datasets[dataSetIndex].dataKey;
			//그래프 안에 함수호출
			vm.searchGraphList(selDataKey);

			return selDataKey;
		}
	} // end if
}
export default chartClickEvent;
